import { logger } from "@/lib/logger";
import { Preferences } from '@capacitor/preferences';

/**
 * Capacitor-compatible storage adapter for Supabase
 * Uses Capacitor Preferences API instead of localStorage for better mobile support
 */
export const capacitorStorage = {
  getItem: async (key: string): Promise<string | null> => {
    try {
      const { value } = await Preferences.get({ key });
      return value;
    } catch (error) {
      logger.error('Error getting item from Capacitor storage:', error);
      return null;
    }
  },
  
  setItem: async (key: string, value: string): Promise<void> => {
    try {
      await Preferences.set({ key, value });
    } catch (error) {
      logger.error('Error setting item in Capacitor storage:', error);
    }
  },
  
  removeItem: async (key: string): Promise<void> => {
    try {
      await Preferences.remove({ key });
    } catch (error) {
      logger.error('Error removing item from Capacitor storage:', error);
    }
  },
};
